import { useMutation } from '@apollo/react-hooks';
import { kmsClient } from 'api';
import { ADD_TEXT_ASSET_ARTICLE_GROUP_MUTATION } from './addTextAssetToArticleGroup.mutation';
import {
  AddTextAssetToArticleGroupMutation,
  AddTextAssetToArticleGroupMutation_addTextAssetToArticleGroup_textAsset,
  AddTextAssetToArticleGroupMutationVariables
} from './__generated__/AddTextAssetToArticleGroupMutation';

type MutationProps = {
  onStart?: () => void;
  onCompleted?: (textAsset: AddTextAssetToArticleGroupMutation_addTextAssetToArticleGroup_textAsset) => void;
  onError?: (errors: string[]) => void;
};

export const useAddTextAssetToArticleGroup = ({ onStart, onCompleted, onError }: MutationProps) => {
  const [mutationFunc] = useMutation<AddTextAssetToArticleGroupMutation, AddTextAssetToArticleGroupMutationVariables>(
    ADD_TEXT_ASSET_ARTICLE_GROUP_MUTATION,
    {
      client: kmsClient,
      onCompleted: (data) => {
        if (data.addTextAssetToArticleGroup?.errors?.length) {
          if (onError) onError(data.addTextAssetToArticleGroup.errors);
        } else {
          if (onCompleted && data.addTextAssetToArticleGroup?.textAsset)
            onCompleted(data.addTextAssetToArticleGroup.textAsset);
        }
      },
      onError: (error) => onError && onError([error.message])
    }
  );
  return (variables: AddTextAssetToArticleGroupMutationVariables) => {
    if (onStart) onStart();
    mutationFunc({ variables });
  };
};
